import { IDeviceStrategy, DeviceInfo, SessionOptions } from './IDeviceStrategy';

/**
 * Strategy for iOS Safari to prevent jetsam memory kills.
 * WebKit 26+ has a known bug with ONNX Runtime JSEP mode that causes memory exhaustion.
 * This strategy forces pure WASM execution without GPU acceleration.
 * See: https://github.com/microsoft/onnxruntime/issues/26827
 */
export class IOSSafariStrategy implements IDeviceStrategy {
  getDeviceInfo(): DeviceInfo {
    return {
      estimatedRAM: 3,
      isLowMemory: true,
      isSlowConnection: false
    };
  }

  getSessionOptions(_debug: boolean): SessionOptions {
    return {
      // Force pure WASM - no WebGL, no WebGPU, no JSEP
      executionProviders: ['wasm'],
      graphOptimizationLevel: 'disabled', // Disable graph optimization to reduce memory
      logSeverityLevel: 4,
      logVerbosityLevel: 0,
      enableCpuMemArena: false, // Don't use CPU memory arena
      enableMemPattern: false, // Don't use memory pattern optimization
      executionMode: 'sequential', // Sequential execution uses less memory
      interOpNumThreads: 1, // Single thread
      intraOpNumThreads: 1, // Single thread
    };
  }

  shouldUseSequentialLoading(): boolean {
    return true;
  }
}
